"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservationComponent = void 0;
/**
 * Measurements and simple assertions made about a patient, device or other subject.
 */
var ObservationComponent = /** @class */ (function () {
    function ObservationComponent() {
    }
    return ObservationComponent;
}());
exports.ObservationComponent = ObservationComponent;
